var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagVirginIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2695C24.8366 32.2695 32 25.1061 32 16.2695C32 7.43297 24.8366 0.269531 16 0.269531C7.16344 0.269531 0 7.43297 0 16.2695C0 25.1061 7.16344 32.2695 16 32.2695Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7178 11.4474C18.7178 9.94661 17.5011 8.72998 16.0003 8.72998C14.4995 8.72998 13.2829 9.94661 13.2829 11.4474H7.30469C7.30469 12.9249 8.59181 14.1229 10.0694 14.1229H9.98037C9.98037 15.6005 11.1781 16.7985 12.6559 16.7985C12.6559 18.1069 13.5956 19.194 14.8365 19.4264L14.8296 19.442H17.1711L17.1642 19.4264C18.4052 19.1939 19.3447 18.1068 19.3447 16.7985C20.8225 16.7985 22.0203 15.6005 22.0203 14.1229H21.9312C23.4088 14.1229 24.6959 12.9249 24.6959 11.4474H18.7178Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8057 19.1646L13.1208 22.9685C14.0098 23.3299 14.9815 23.5307 16.0003 23.5307C17.0192 23.5307 17.9908 23.3299 18.8798 22.9685L17.195 19.1646H14.8057Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5215 12.7837V17.4644C12.5215 20.1268 15.9997 20.9426 15.9997 20.9426C15.9997 20.9426 19.478 20.1268 19.478 17.4644V12.7837H12.5215Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87967 16.3823L5.76086 21.6438L7.62248 16.3823H9.04323L6.32911 23.3388H5.19255L2.45898 16.3823H3.87967Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7393 23.3388V16.3823H27.0913V23.3388H25.7393Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9131 14.2954V19.9675C14.3913 20.3195 14.9058 20.5615 15.3044 20.7165V14.2954H13.9131Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0866 14.2954V19.9675C17.6084 20.3195 17.0939 20.5615 16.6953 20.7165V14.2954H18.0866Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5215 12.7837H19.478V14.9909H12.5215V12.7837Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.269531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagVirginIslands);
export default __webpack_public_path__ + "static/media/flag_virgin_islands.a414da21a45fd22a7a686d1c7924f3ea.svg";
export { ForwardRef as ReactComponent };